module.exports = __webpack_public_path__ + "static/pic08.fe7e3185.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic08.jpg
// module id = 54
// module chunks = 37880801899593 65868693374900 263791100135453